import React from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import "./style.scss";

const CNBTextArea = ({
  label = "",
  containerClassName = "",
  requiredIcon = false,
  meta = { touched: false, error: null },
  input = {},
  ...props
}) => (
  <div
    className={classnames("cnb-textarea", containerClassName, {
      error: meta.touched && meta.error,
    })}
  >
    {label && (
      <>
        <FormattedMessage id={label} tagName="label" />
      </>
    )}
    {requiredIcon && (
      <img
        src="/assets/images/required.png"
        style={{
          position: "absolute",
          width: 10,
          height: 10,
          left: "125px",
          top: "15px",
        }}
      />
    )}
    <textarea {...input} {...props} />
    {meta.touched && meta.error && <span>{meta.error}</span>}
  </div>
);

export default CNBTextArea;
